"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var Utils = tslib_1.__importStar(require("../util/utils"));
var rest_1 = tslib_1.__importDefault(require("./rest"));
var eventemitter_1 = tslib_1.__importDefault(require("../util/eventemitter"));
var logger_1 = tslib_1.__importDefault(require("../util/logger"));
var connection_1 = tslib_1.__importDefault(require("./connection"));
var realtimechannel_1 = tslib_1.__importDefault(require("./realtimechannel"));
var defaults_1 = tslib_1.__importDefault(require("../util/defaults"));
var errorinfo_1 = tslib_1.__importDefault(require("../types/errorinfo"));
var Realtime = /** @class */ (function (_super) {
    tslib_1.__extends(Realtime, _super);
    function Realtime(options) {
        var _this = _super.call(this, options) || this;
        logger_1["default"].logAction(logger_1["default"].LOG_MINOR, 'Realtime()', '');
        _this.connection = new connection_1["default"](_this, _this.options);
        _this.channels = new Channels(_this);
        if (options.autoConnect !== false)
            _this.connect();
        return _this;
    }
    Realtime.prototype.connect = function () {
        logger_1["default"].logAction(logger_1["default"].LOG_MINOR, 'Realtime.connect()', '');
        this.connection.connect();
    };
    Realtime.prototype.close = function () {
        logger_1["default"].logAction(logger_1["default"].LOG_MINOR, 'Realtime.close()', '');
        this.connection.close();
    };
    Realtime.Promise = function (options) {
        options = defaults_1["default"].objectifyOptions(options);
        options.promises = true;
        return new Realtime(options);
    };
    Realtime.Callbacks = Realtime;
    return Realtime;
}(rest_1["default"]));
var Channels = /** @class */ (function (_super) {
    tslib_1.__extends(Channels, _super);
    function Channels(realtime) {
        var _this = _super.call(this) || this;
        _this.realtime = realtime;
        _this.all = {};
        _this.inProgress = {};
        realtime.connection.connectionManager.on('transport.active', function () {
            _this.onTransportActive();
        });
        return _this;
    }
    Channels.prototype.onChannelMessage = function (msg) {
        var channelName = msg.channel;
        if (channelName === undefined) {
            logger_1["default"].logAction(logger_1["default"].LOG_ERROR, 'Channels.onChannelMessage()', 'received event unspecified channel, action = ' + msg.action);
            return;
        }
        var channel = this.all[channelName];
        if (!channel) {
            logger_1["default"].logAction(logger_1["default"].LOG_ERROR, 'Channels.onChannelMessage()', 'received event for non-existent channel: ' + channelName);
            return;
        }
        channel.onMessage(msg);
    };
    /* called when a transport becomes connected; reattempt attach/detach
     * for channels that are attaching or detaching.
     * Note that this does not use inProgress as inProgress is only channels which have already made
     * at least one attempt to attach/detach */
    Channels.prototype.onTransportActive = function () {
        for (var channelName in this.all) {
            var channel = this.all[channelName];
            if (channel.state === 'attaching' || channel.state === 'detaching') {
                channel.checkPendingState();
            }
            else if (channel.state === 'suspended') {
                channel.attach();
            }
        }
    };
    Channels.prototype.reattach = function (reason) {
        for (var channelId in this.all) {
            var channel = this.all[channelId];
            /* NB this should not trigger for merely attaching channels, as they will
             * be reattached anyway through the onTransportActive checkPendingState */
            if (channel.state === 'attached') {
                channel.requestState('attaching', reason);
            }
        }
    };
    Channels.prototype.resetAttachedMsgIndicators = function () {
        for (var channelId in this.all) {
            var channel = this.all[channelId];
            if (channel.state === 'attached') {
                channel._attachedMsgIndicator = false;
            }
        }
    };
    Channels.prototype.checkAttachedMsgIndicators = function (connectionId) {
        for (var channelId in this.all) {
            var channel = this.all[channelId];
            if (channel.state === 'attached' && channel._attachedMsgIndicator === false) {
                var msg = '30s after a resume, found channel which has not received an attached; channelId = ' +
                    channelId +
                    '; connectionId = ' +
                    connectionId;
                logger_1["default"].logAction(logger_1["default"].LOG_ERROR, 'Channels.checkAttachedMsgIndicators()', msg);
                channel.requestState('attaching');
            }
        }
    };
    /* Connection interruptions (ie when the connection will no longer queue
     * events) imply connection state changes for any channel which is either
     * attached, pending, or will attempt to become attached in the future */
    Channels.prototype.propogateConnectionInterruption = function (connectionState, reason) {
        var connectionStateToChannelState = {
            closing: 'detached',
            closed: 'detached',
            failed: 'failed',
            suspended: 'suspended',
        };
        var fromChannelStates = ['attaching', 'attached', 'detaching', 'suspended'];
        var toChannelState = connectionStateToChannelState[connectionState];
        for (var channelId in this.all) {
            var channel = this.all[channelId];
            if (Utils.arrIn(fromChannelStates, channel.state)) {
                channel.notifyState(toChannelState, reason);
            }
        }
    };
    Channels.prototype.get = function (name, channelOptions) {
        name = String(name);
        var channel = this.all[name];
        if (!channel) {
            channel = this.all[name] = new realtimechannel_1["default"](this.realtime, name, channelOptions);
        }
        else if (channelOptions) {
            if (channel._shouldReattachToSetOptions(channelOptions)) {
                throw new errorinfo_1["default"]('Channels.get() cannot be used to set channel options that would cause the channel to reattach. Please, use RealtimeChannel.setOptions() instead.', 40000, 400);
            }
            channel.setOptions(channelOptions);
        }
        return channel;
    };
    /* Included to support certain niche use-cases; most users should ignore this.
     * Please do not use this unless you know what you're doing */
    Channels.prototype.release = function (name) {
        name = String(name);
        var channel = this.all[name];
        if (!channel) {
            return;
        }
        var releaseErr = channel.getReleaseErr();
        if (releaseErr) {
            throw releaseErr;
        }
        delete this.all[name];
        delete this.inProgress[name];
    };
    /* Records operations currently pending on a transport; used by connectionManager to decide when
     * it's safe to upgrade. Note that a channel might be in the attaching state without any pending
     * operations (eg if attached while the connection state is connecting) - such a channel must not
     * hold up an upgrade, so is not considered inProgress.
     * Operation is currently one of either 'statechange' or 'sync' */
    Channels.prototype.setInProgress = function (channel, operation, inProgress) {
        this.inProgress[channel.name] = this.inProgress[channel.name] || {};
        this.inProgress[channel.name][operation] = inProgress;
        if (!inProgress && this.hasNopending()) {
            this.emit('nopending');
        }
    };
    Channels.prototype.onceNopending = function (listener) {
        if (this.hasNopending()) {
            listener();
            return;
        }
        this.once('nopending', listener);
    };
    Channels.prototype.hasNopending = function () {
        return Utils.arrEvery(Utils.valuesArray(this.inProgress, true), function (operations) {
            return !Utils.containsValue(operations, true);
        });
    };
    return Channels;
}(eventemitter_1["default"]));
exports["default"] = Realtime;
